module.exports = __webpack_public_path__ + "static/media/icon-dekton.6e9aa102.png";